import { createElement, useEffect, useState } from 'react';
import { Box } from '@alifd/next';
import './index.scss';
import { entityMetadataUtil, eventUtil, entityPageUtil } from 'oadp-common';
import OadpAttributeSettingTransfer from '../common/oadp-attribute-setting-transfer';
const OadpEntityButtonSettingTable = function OadpEntityButtonSettingTable({ entity, tableComponentRefId, __designMode, ...otherProps }) {
    const [attributeDataSource, setAttributeDataSource] = useState([]);
    const [attributeShowDataSource, setAttributeShowDataSource] = useState([]);
    useEffect(() => {
        const fetchAttributeData = async () => {
            try {
                console.log('OadpEntityButtonSettingTable componentDidMount props', { entity, tableComponentRefId });
                if (!entity) {
                    console.log('OadpEntityButtonSettingTable componentDidMount entity is undefined');
                    return;
                }
                const attributeData = await entityMetadataUtil.asyncSelectAttributeListWithReferByEntityId(entity);
                console.log('OadpEntityButtonSettingTable componentDidMount attributeData', attributeData);
                let textAttributeDataSource = [];
                attributeData.list.forEach((item) => {
                    if (item.attributeType?.code === 'TEXT' || item.attributeType?.code === 'MULTI_TEXT') {
                        textAttributeDataSource.push({
                            ...item,
                            label: item.name,
                            value: item.attributeType?.code === 'REFER' ? `${item.logicalName}.name` : item.logicalName
                        });
                    }
                });
                setAttributeDataSource(textAttributeDataSource);
            }
            catch (error) {
                console.error('OadpEntityButtonSettingTable componentDidMount Failed to fetch field options:', error);
            }
        };
        fetchAttributeData();
    }, [entity]);
    const handleDialogOpen = () => {
        if (__designMode === 'design') {
            console.log('OadpEntityButtonSettingTable handleDialogOpen __designMode === design');
            return;
        }
        const tableShowColumnList = entityPageUtil.getTableShowColumnList(tableComponentRefId);
        console.log('OadpEntityButtonSettingTable handleDialogOpen tableShowColumnList', tableShowColumnList);
        if (tableShowColumnList && Array.isArray(tableShowColumnList)) {
            setAttributeShowDataSource(tableShowColumnList);
        }
    };
    const handleDialogOk = (attributeShowDataSource) => {
        console.log('OadpEntityButtonSettingTable handleDialogOk attributeShowDataSource', attributeShowDataSource);
        eventUtil.refreshOadpEntityTableColumn({
            tableComponentRefId: tableComponentRefId,
            showColumnList: attributeShowDataSource
        });
    };
    return (createElement(Box, null,
        createElement(OadpAttributeSettingTransfer, { attributeDataSource: attributeDataSource, attributeShowDataSource: attributeShowDataSource, onOpen: handleDialogOpen, onConfirm: handleDialogOk, __designMode: __designMode })));
};
export default OadpEntityButtonSettingTable;
